<template>
  <div v-if="agentSynonyms.length > 0">
    <h1 class="is-size-5 has-margin-bottom-small">Synonyms for the Agent</h1>
    <b-table
      :columns="columns"
      :data="agentSynonyms"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      columns: [
        {
          field: 'reference',
          label: 'Reference',
          width: 120
        },
        {
          field: 'name',
          label: 'Synonym'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['agentSynonyms'])
  }
}
</script>

<style>

</style>
